import { ReactNode, FC, useEffect } from 'react';
import { IntercomProvider, useIntercom } from 'react-use-intercom';
import Environment from '@/lib/environment';
import useApp from '@/hooks/use-app.hook';
import { useQuery } from 'react-query';
import { QueryKey } from '@/lib/query-client';
import { getSupportToken } from '@/lib/services/auth.service';

interface Props {
  children: ReactNode;
}

const { INTERCOM_APP_ID, INTERCOM_API_BASE } = Environment;

interface Props {
  children: ReactNode;
}

const SupportProviderWithContext: FC<Props> = ({ children }) => {
  const { signedIn, user } = useApp();
  const { update } = useIntercom();
  const { spUserId } = user || { spUserId: '' };

  const { data: supportToken } = useQuery(
    [QueryKey.SupportToken, spUserId],
    async () => getSupportToken(),
    { enabled: signedIn }
  );

  useEffect(() => {
    if (supportToken && spUserId) {
      update({
        userId: spUserId,
        intercomUserJwt: supportToken.jwt,
      });
    }
  }, [update, supportToken, spUserId]);

  return children;
};

export const SupportProvider: FC<Props> = ({ children }) => {
  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      apiBase={INTERCOM_API_BASE}
      autoBoot
      autoBootProps={{
        hideDefaultLauncher: true,
      }}
    >
      <SupportProviderWithContext>{children}</SupportProviderWithContext>
    </IntercomProvider>
  );
};
